import { Component, inject, OnInit, signal } from '@angular/core';
import { LetterViewComponent } from '../letter-view/letter-view.component';
import { AccomodationService } from '../../../services/accomodation.service';
import { IAccommodationOfferShort } from '../../../interfaces/interface';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

@Component({
  selector: 'app-letter',
  imports: [LetterViewComponent],
  templateUrl: './letter.component.html',
  styleUrl: './letter.component.scss',
})
export class LetterComponent implements OnInit {
  private router = inject(Router);
  private accomService = inject(AccomodationService);
  private activateRoute = inject(ActivatedRoute);

  public caseToken = signal<string>('');
  public listOffers = signal<IAccommodationOfferShort[] | null>(null);
  public isErrorRequest = signal<boolean>(false);
  public errorMessage = signal<string | undefined>('');

  public isConfirmedOfferForCurrentUser = signal<boolean>(false);

  constructor() {
    //caseToken
    this.loadDataCaseToken();
    this.accomService.setCaseToken(this.caseToken());

    //offers
    this.loadOffers();
  }

  ngOnInit(): void {
    if (!this.accomService.isBooked()) return;

    const offerId = this.accomService.getBookedId();
    if (offerId == null) return;
  }

  public clientName = signal('');

  public goToOffer(offerId: number) {
    this.router.navigate(['accommodation', offerId], {
      relativeTo: this.activateRoute,
      queryParamsHandling: 'merge',
    });
  }

  private loadDataCaseToken(): void {
    const token = this.activateRoute.snapshot.queryParamMap.get('caseToken');
    this.caseToken.set(token || '');
    if (this.caseToken) {
      this.accomService.setCaseToken(this.caseToken());
    }
  }

  private loadOffers() {
    this.accomService
      .getOffers()
      .pipe(
        map(data => {
          this.listOffers.set(data);
          if (this.listOffers()?.length) {
            this.clientName.set(
              `${this.listOffers()![0].first_name} ${this.listOffers()![0].surname}`
            );
          }

          this.isErrorRequest.set(false);
        }),
        catchError(err => {
          console.error('Failed to load offers', err);
          this.errorMessage.set(err?.error?.errors?.[0]?.params?.[0]);
          this.isErrorRequest.set(this.errorMessage() ? true : false);
          return of(null);
        })
      )
      .subscribe();
  }
}
